import { Expose } from "class-transformer";

export class CreateStopTaskDto {
  @Expose()
  stopped: boolean;
}
